import React from "react";
import PropTypes from "prop-types";
import Button from "../../components/Button";

import Api from "../../Api";

import AdminBrand from "./Brand";
import AdminBrandEdit from "./AdminBrandEdit";
import AdminBrandCreate from "./AdminBrandCreate";
import AdminCollections from "./AdminCollections";
import AdminCollectionEdit from "./AdminCollectionEdit";
import AdminEmails from "./AdminEmails";
import AdminProduct from "./AdminProduct";
import AdminProductOptionEdit from "./AdminProductOptionEdit";
import AdminRecommendations from "./AdminRecommendations";
import AdminRetailer from "./Retailer";
import AdminRetailerView from "./RetailerView";
import AdminOrders from "./Orders";
import AdminQueue from "./AdminQueue";
import AdminSingleOrder from "./SingleOrder";
import AdminTools from "./AdminTools";

import "./Admin.less";

export default class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.userChanged = this.userChanged.bind(this);
    this.state = {user: null};
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.userChanged, Api.cache.eventTypes.USER_CHANGED);
    Api.getUser(true)
      .then(() => {
        this.userChanged();
      });
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.userChanged, Api.cache.eventTypes.USER_CHANGED);
  }

  userChanged() {
    let user = Api.cache.getUser();

    if (!user) {
      this.context.router.push('/user?redirect=/admin');
    } else if (!user.is_employee) {
      this.context.router.push('/');
    } else {
      this.setState({user: user});
    }
  }

  render() {
    if (!this.state.user) return null;
    if (this.props.location && this.props.location.isModal) return this.props.children;

    return (
      <div className="admin">
        <div className="admin-inner-wrapper">
          <div className="column body-content">
            <div className="admin-banner">
              <Button color="dark" to="/admin">Brands</Button>
              <Button color="dark" to="/admin/retailers">Retailers</Button>
              <Button color="dark" to="/admin/collections">Collections</Button>
              <Button color="dark" to="/admin/orders">Orders</Button>
            </div>

            <div className="admin-banner">
              <Button color="dark" to="/admin/emails">Emails</Button>
              <Button color="dark" to="/admin/recommendations">Email Recommendations</Button>
              <Button color="dark" to="/admin/tools">Tools</Button>
              <Button color="dark" to="/admin/queue">Queue</Button>
            </div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

Admin.contextTypes = {
  router: PropTypes.object
};

export {
  AdminBrand,
  AdminBrandEdit,
  AdminBrandCreate,
  AdminCollections,
  AdminCollectionEdit,
  AdminEmails,
  AdminProduct,
  AdminProductOptionEdit,
  AdminRecommendations,
  AdminRetailer,
  AdminRetailerView,
  AdminOrders,
  AdminQueue,
  AdminSingleOrder,
  AdminTools
};



/** WEBPACK FOOTER **
 ** ./src/views/admin/Admin.js
 **/